import jwt_decode from "jwt-decode";
import { User } from "../hooks/auth";

export  function getUserFromToken (token: string): User {
  try {
    var decoded: User = jwt_decode(token);
    return decoded
  } catch {
    return {} as User
  }
  }